<div *ngIf="!partnerBoolean">
    <div *ngIf="this.hasAangeverWinst()">
        <snelstart-venture-fiscaal-feature-overzicht-winst-uit-onderneming
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-winst-uit-onderneming>
    </div>

    <div *ngIf="this.hasAangeverLoon()">
        <snelstart-venture-fiscaal-feature-overzicht-loon
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-loon>
    </div>

    <div *ngIf="this.hasAangeverRow()">
        <snelstart-venture-fiscaal-feature-overzicht-resultaat-overige-werkzaamheden
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-resultaat-overige-werkzaamheden>
    </div>

    <div *ngIf="this.hasAangeverPerUitk()">
        <snelstart-venture-fiscaal-feature-overzicht-periodieke-uitkeringen
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-periodieke-uitkeringen>
    </div>

    <div *ngIf="this.hasAangeverEigenWoning()">
        <snelstart-venture-fiscaal-feature-overzicht-eigen-woning
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-eigen-woning>
    </div>

    <div *ngIf="hasAangeverLijfrente()">
        <snelstart-venture-fiscaal-feature-overzicht-lijfrente
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-lijfrente>
    </div>

    <div *ngIf="hasAangeverNegatieveLijfrente()">
        <snelstart-venture-fiscaal-feature-overzicht-neg-inkomensvoorziening
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-neg-inkomensvoorziening>
    </div>
    <div *ngIf="hasAangeverNegatievePga()">
        <snelstart-venture-fiscaal-feature-overzicht-neg-pga
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-neg-pga>
    </div>

    <div *ngIf="hasAangeverVerrekendVerliesBox1()">
        <snelstart-venture-fiscaal-feature-overzicht-verliescompensatie-box1
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-verliescompensatie-box1>
    </div>
</div>

<div *ngIf="partnerBoolean">

    <div *ngIf="this.hasPartnerWinst()">
        <snelstart-venture-fiscaal-feature-overzicht-winst-uit-onderneming
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-winst-uit-onderneming>
    </div>

    <div *ngIf="this.hasPartnerLoon()">
        <snelstart-venture-fiscaal-feature-overzicht-loon
                [partner]="partner" [partnerRapport]="partnerRapport"
                [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-loon>
    </div>

    <div *ngIf="this.hasPartnerRow()">
        <snelstart-venture-fiscaal-feature-overzicht-resultaat-overige-werkzaamheden
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-resultaat-overige-werkzaamheden>
    </div>

    <div *ngIf="this.hasPartnerPerUitk()">
        <snelstart-venture-fiscaal-feature-overzicht-periodieke-uitkeringen
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-periodieke-uitkeringen>
    </div>

    <div *ngIf="this.hasPartnerEigenWoning()">
        <snelstart-venture-fiscaal-feature-overzicht-eigen-woning
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-eigen-woning>
    </div>

    <div *ngIf="hasPartnerLijfrente()">
        <snelstart-venture-fiscaal-feature-overzicht-lijfrente
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-lijfrente>
    </div>

    <div *ngIf="hasPartnerNegatieveLijfrente()">
        <snelstart-venture-fiscaal-feature-overzicht-neg-inkomensvoorziening
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-neg-inkomensvoorziening>
    </div>
    <div *ngIf="hasPartnerNegatievePga()">
        <snelstart-venture-fiscaal-feature-overzicht-neg-pga
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-neg-pga>
    </div>

    <div *ngIf="hasPartnerVerrekendVerliesBox1()">
        <snelstart-venture-fiscaal-feature-overzicht-verliescompensatie-box1
                [partner]="partner" [aangifteRapport]="aangifteRapport" [partnerRapport]="partnerRapport"
                [berekening]="berekening" [partnerBerekening]="partnerBerekening">
        </snelstart-venture-fiscaal-feature-overzicht-verliescompensatie-box1>
    </div>

</div>


<form [formGroup]="berekeningBox1FormGroup">
    <div>
        <div formGroupName="box1">
            <div class="row">
                <div class="col col-1" *ngIf="!this.partnerBoolean">
                    <p><b>Inkomen uit werk en woning (box 1) voor {{ this.dataService.naamAangever}}</b></p>
                </div>
                <div class="col col-1" *ngIf="this.partnerBoolean">
                    <p><b>Inkomen uit werk en woning (box 1) voor {{ this.dataService.naamPartner}}</b></p>
                </div>
                <div class="col-2"></div>
                <div class="col-3">
                    <snelstart-ui-number-form-control
                            formControlName="inkomen"
                            id="inkomen"
                            class="custom-input-150"
                            [decimals]="0"
                            [disabledControl]="true"
                            align="right"
                            prefix="€"
                    ></snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </div>
    </div>
</form>





